module.exports = __webpack_public_path__ + "static/media/cis-200.6465c375.png";